


























import { Component, Prop, Vue } from 'vue-property-decorator';
import avatars from '../../enums/avatars';

@Component
export default class ColorBox extends Vue {
  @Prop({ default: () => [] }) private usedColors!: string[];

  @Prop({ default: 0 }) private x!: number;

  @Prop({ default: 0 }) private y!: number;

  @Prop({ default: '' }) private currentColor!: string;

  select = '';

  avatars = avatars;

  get top(): string {
    return `${this.y}px`;
  }

  get left(): string {
    return `${this.x}px`;
  }

  changeColor(e: Event): void {
    if (e.target instanceof Element) {
      const { target } = e;
      let targetColor: string | null = target.getAttribute('data-color');
      if (!targetColor) targetColor = '';
      if (!this.usedColors.includes(targetColor)) {
        this.select = targetColor;
      }
      if (targetColor === this.currentColor) {
        this.select = targetColor;
      }
      this.$store.commit('setCurrentColor', this.select);
      this.$emit('change-color', this.select);
    }
  }
}
